(function () {

  'use strict';

  angular
    .module('eclipseApp.core')
    .directive('fidoPasswordCriteria', fidoPasswordCriteria);

  fidoPasswordCriteria.$inject = ['$compile', '$templateRequest'];

  function fidoPasswordCriteria($compile, $templateRequest) {
    return {
      restrict: 'AE',
      require: 'ngModel',
      scope: {
        config: '=fidoPasswordCriteria'
      },
      link: function ($scope, $element, $attrs, ngModel) {
        var validationRules = {
          letter: /[a-zA-Z]/,
          number: /[0-9]/,
          validchar: /^[a-zA-Z0-9!@#\$]{0,}$/
        };

        $scope.validation = {
          isCapsLockOn: false,
          hasLetter: false,
          hasMinLength: false,
          hasNumber: false,
          hasValidChar: true
        };

        $templateRequest('modules/core/password-criteria/password-criteria.view.html')
          .then(function (html) {
            var template = angular.element(html);
            $(template).insertAfter($element);
            $compile(template)($scope);

            $element.on('keyup', onKeyUpHandler);
            $element.on('keypress', capsLockHandler);
          });

        $scope.$on('$destroy', function () {
          $element.off('keyup', onKeyUpHandler);
          $element.off('keypress', capsLockHandler);
        });

        function onKeyUpHandler(e) {
          // for checking password, we should use keyup, because keypress doesn't detect backspace
          $scope.$apply(function () {
            var password = e.target.value;

            $scope.validation.hasLetter = validatePassword(password, 'letter');
            $scope.validation.hasNumber = validatePassword(password, 'number');
            $scope.validation.hasValidChar = validatePassword(password, 'validchar');
            $scope.validation.hasMinLength = validatePassword(password, 'minlength');
          });
        }

        function capsLockHandler(e) {
          // for checking capseLock, we should use keypress event as keyup hold capital letter value
          var keyCode = e.keyCode ? e.keyCode : e.which;
          var fromCharCode = String.fromCharCode(keyCode);
          $scope.validation.isCapsLockOn = (fromCharCode.toUpperCase() === fromCharCode && fromCharCode.toLowerCase() !== fromCharCode && !e.shiftKey) && (e.keyCode !== 20);
        }

        function validatePassword(password, rule) {
          var isValid;
          if (rule === 'minlength') {
            isValid = password.length >= 8;
          } else {
            isValid = validationRules[rule].test(password);
          }
          ngModel.$setValidity(rule, isValid);
          return isValid;
        }
      }
    };
  }
})();
